export const getMockBackendHtml = (name: string, logoSrc?: string | null) => {
    return `<!DOCTYPE html>
<html lang="ru">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Официальная платёжная страница</title>
</head>
<body style="font-family: Arial, sans-serif; margin: 0; padding: 20px; background-color: #f5f5f5; color: #333;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
        <div style="color: #2c3e50; text-align: center; margin-bottom: 30px;">
            <h1 style="">Официальная платёжная страница, </h1>
            ${name ? `<h1 style="">${name}</h1>` : '<span style="font-size: 18px; background: #FEDFDF">заполните поле "Название вашего проекта"</span>'}
        </div>

        <div style="background-color: #f8f9fa; padding: 15px; border-radius: 6px; margin-bottom: 20px; margin-top: 20px;">
            <p style="margin: 0; line-height: 1.5; color: #555;">Для приёма платежей мы используем надёжное и безопасное платёжное решение. Процедура оплаты проста, деньги зачисляются мгновенно. Ваши данные передаются по защищённым каналам связи.</p>
        </div>
        
        <div style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div style="background-color: #4a6bdf; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 10px;">1</div>
                <span>Введите номер заказа</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div style="background-color: #4a6bdf; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 10px;">2</div>
                <span>Введите номер мобильного телефона</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div style="background-color: #4a6bdf; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 10px;">3</div>
                <span>Укажите сумму оплаты</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div style="background-color: #4a6bdf; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 10px;">4</div>
                <span>Нажмите кнопку «Оплатить»</span>
            </div>
            <div style="display: flex; align-items: center;">
                <div style="background-color: #4a6bdf; color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 10px;">5</div>
                <span>Выберите метод оплаты</span>
            </div>
        </div>
        
        <form style="margin-top: 30px;">
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">Номер заказа:</label>
                <input type="text" value="счёт-001" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;">
            </div>
            
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">Мобильный телефон:</label>
                <div style="color: #888; margin-bottom: 5px; font-size: 14px;">другая страна?</div>
                <input type="tel" value="+7 000 000-00-00" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;">
            </div>
            
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">e-mail:</label>
                <input type="email" value="email@domain.com" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;">
            </div>
            
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">валюта:</label>
                <input type="text" value="RUB" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box;">
            </div>
            
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">дополнительные данные:</label>
                <textarea style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; height: 80px;">адрес, пожелания, любая информация, которая поможет выполнить заказ</textarea>
            </div>
            
            <div style="margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: bold;">сумма к оплате:</label>
                <input type="text" value="00.00" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; font-weight: bold; font-size: 18px;">
            </div>
            
            <div style="margin-bottom: 20px;">
                <label style="display: flex; align-items: flex-start;">
                    <input type="checkbox" style="margin-right: 10px; margin-top: 3px;">
                    <span>Согласие на получение рекламно-информационной рассылки</span>
                </label>
            </div>
            
            <div style="margin-bottom: 20px; font-size: 13px; color: #666; line-height: 1.4;">
                Нажимая кнопку «ОПЛАТИТЬ», я даю Согласие на обработку персональных данных и принимаю Политику обработки персональных данных ООО «Продамус» (не является продавцом Вашего заказа)*
            </div>
            
            <button type="submit" style="width: 100%; padding: 15px; background-color: #4a6bdf; color: white; border: none; border-radius: 4px; font-size: 18px; font-weight: bold; cursor: pointer;">
                Оплатить
            </button>
        </form>
    </div>
</body>
</html>`
}